module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-breakdown"
  }, [_vm._l((_vm.loadsOrderedByLoadingDate), function(load, index) {
    return _c('admin-load', {
      key: load.id,
      attrs: {
        "load": load,
        "index": index
      }
    })
  }), _vm._v(" "), (_vm.haveNoLoads) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n          There are no loads.\n        ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [(_vm.canFinaliseJob) ? _c('a', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-last-load"
    }
  }, [_vm._v("Finalise Job")]) : _vm._e(), _vm._v(" "), (_vm.canUnfinaliseJob) ? _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleUnfinaliseJob,
      "size": "small",
      "type": "warning"
    }
  }, [_vm._v("\n            Unfinalise\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "assigned"
  }, [_vm._v("Assigned: " + _vm._s(_vm.loadSize) + " of " + _vm._s(_vm.jobSize) + " tonnes. (" + _vm._s(_vm.loadPercentage) + "%)")])])])])]), _vm._v(" "), (_vm.jobIsEditable) ? [_c('load-planner'), _vm._v(" "), (_vm.canFinaliseJob) ? _c('last-load-modal') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.haveLoadWithWeighbridge) ? _c('load-check-modal') : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Load Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-c30f1ccc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/AdminLoadList.vue
// module id = 1074
// module chunks = 0